module.exports = __webpack_public_path__ + "static/img/C4D0015.3a5f8cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0015.jpg
// module id = QkR6
// module chunks = 0